// @ts-nocheck
import { useContext } from "react";

import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  optionsFetchRecomendUser,
  optionsFetchSearchUser,
} from "@/config/plugins/user.query-options.ts";
import { SubmitHandler, useForm } from "react-hook-form";
import { Genders, UpdateUser } from "@/integration/user/interfaces/IUser.ts";
import userService from "@/integration/user/services/user.service.ts";
import { QUERY_KEY_USER } from "@integration/factory/queryKeys.constants.ts";
import { extractNumbers } from "@/utils/extractNumbers.ts";
import { yupResolver } from "@hookform/resolvers/yup";
import { UserUpdateSchema } from "@/integration/user/interfaces/validations/user.schema.ts";
import ToastContextExports from "@/context/ToastContext.tsx";
import UserContextExports from "@/context/UserContext.tsx";
import { FileBussinessType } from "@/integration/application/interfaces/file.interface.ts";

const useUser = () => {
  const {
    user: userAuth,
    files: filesAuth,
    isLoadingAuth,
  } = useContext(UserContextExports.Context);

  const { putProfile } = userService();

  const { showToast } = ToastContextExports.useToast();

  const queryClient = useQueryClient();

  const avatarFile = filesAuth.find(
    (item) => item.business_type === FileBussinessType.USER_PROFILE_PHOTO
  );

  const bannerFile = filesAuth.find(
    (item) => item.business_type === FileBussinessType.USER_PROFILE_BANNER
  );

  const searchUser = (name: string) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data } = useQuery(optionsFetchSearchUser(name));

    return data;
  };

  const { data: recomendDataUser } = useQuery({
    ...optionsFetchRecomendUser(),
    enabled: Boolean(userAuth?.id),
  });

  const submitUpdateUserProfile: SubmitHandler<UpdateUser> = async (values) => {
    if (userAuth?.id === undefined) {
      return;
    }
    try {
      const { cpf, ...rest } = values;
      await putProfile(userAuth?.id, {
        ...rest,
        phone: extractNumbers(values.phone),
        cpf: extractNumbers(cpf),
      });

      queryClient.invalidateQueries({ queryKey: [QUERY_KEY_USER.PROFILE] });
      showToast("Sucesso", "Perfil atualizado com sucesso.", "success");
    } catch (error) {
      console.error("Erro ao atualizar perfil:", error);
    }
  };

  const {
    register: formRegisterProfile,
    handleSubmit: handleSubmitProfile,
    reset: resetFormProfile,
    formState: { errors, isSubmitted, isValid },
  } = useForm<UpdateUser>({
    resolver: yupResolver(UserUpdateSchema),
    values: {
      name: userAuth?.name || "",
      nick: userAuth?.nick || "",
      gender: userAuth?.gender || Genders.NOT_INFORMED,
      phone: userAuth?.phone || "",
      cpf: userAuth?.cpf || "",
      about: userAuth?.about || "",
      birth: userAuth?.birth || "",
    },
  });

  return {
    userAuth,
    filesAuth,
    teams: userAuth?.teams || [],
    avatarFile,
    bannerFile,
    setup: {},
    searchUser,
    recomendDataUser,
    isLoadingAuth,
    formUpdateProfileUser: {
      handleSubmitProfileUser: handleSubmitProfile,
      submitUpdateUserProfile,
      formRegisterProfileUser: formRegisterProfile,
      resetFormProfile,
      isSubmitted,
      isValid,
      errors,
    },
  };
};


export default useUser;
